/* ════════════════════════════════════════════════════════════════
   Tessera Diamonds — GTM dataLayer event tracking
   Single delegated listener; events declared via data-track-event="..."
   on any clickable element. All data-track-* attrs flow as event props.
   ════════════════════════════════════════════════════════════════ */
(function(){
  if (!window.dataLayer) window.dataLayer = [];

  // ─── Public helper for programmatic events (e.g. theme toggle JS) ───
  window.tdTrack = function(name, props){
    if (!name) return;
    var payload = { event: name };
    if (props && typeof props === 'object') {
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) payload[k] = props[k];
      }
    }
    window.dataLayer.push(payload);
  };

  // ─── Click delegation ───────────────────────────────────────────
  document.addEventListener('click', function(e){
    // 1. Explicit data-track-event attribute (most common)
    var attrEl = e.target.closest('[data-track-event]');
    if (attrEl) {
      var name = attrEl.getAttribute('data-track-event');
      var props = collectDataProps(attrEl);
      enrichLinkProps(attrEl, props);
      window.tdTrack(name, props);
      return;
    }

    // 2. Class-based auto-tracking (no attribute needed)
    var auth = e.target.closest('.auth-link');
    if (auth) {
      window.tdTrack('outbound_authority', {
        text: auth.textContent.trim().substring(0, 80),
        url: auth.href || '',
        page_location: location.pathname
      });
      return;
    }

    var verify = e.target.closest('.gia-strip__link, .verify-cert__btn');
    if (verify) {
      window.tdTrack('outbound_cert_verify', {
        text: verify.textContent.trim().substring(0, 40),
        url: verify.href || '',
        page_location: location.pathname
      });
      return;
    }
  }, true);

  // ─── FAQ <details> open ─────────────────────────────────────────
  document.addEventListener('toggle', function(e){
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS') return;
    if (!d.open) return; // only fire on open
    // Auto-detect FAQ context by class
    var loc = '';
    if (d.classList.contains('pdp-faq__item')) loc = 'pdp';
    else if (d.classList.contains('cat-faq__item')) loc = 'hub';
    else if (d.classList.contains('coll-faq__item')) loc = 'collection';
    else if (d.classList.contains('faq-item')) loc = 'faq_page';
    else if (d.hasAttribute('data-track-faq')) loc = d.getAttribute('data-track-faq');
    else return;
    var q = d.querySelector('summary');
    window.tdTrack('faq_expanded', {
      question: q ? q.textContent.trim().substring(0, 120) : '',
      faq_location: loc,
      page_location: location.pathname
    });
  }, true);

  // ─── Form submissions for verify-cert ───────────────────────────
  document.addEventListener('submit', function(e){
    if (e.target && e.target.id === 'verify-cert-form') {
      var lab = (document.getElementById('vc-lab') || {}).value;
      var num = (document.getElementById('vc-num') || {}).value;
      window.tdTrack('cert_verify_submitted', {
        lab: lab,
        has_cert_number: num ? true : false
      });
    }
  }, true);

  // ─── Helpers ────────────────────────────────────────────────────
  function collectDataProps(el){
    var props = {};
    var attrs = el.attributes;
    for (var i = 0; i < attrs.length; i++) {
      var a = attrs[i];
      if (a.name.indexOf('data-track-') === 0 && a.name !== 'data-track-event') {
        // data-track-product-id → product_id
        var key = a.name.substring(11).replace(/-/g, '_');
        props[key] = a.value;
      }
    }
    if (!props.text && el.textContent) {
      props.text = el.textContent.trim().replace(/\s+/g, ' ').substring(0, 80);
    }
    return props;
  }

  function enrichLinkProps(el, props){
    if (el.tagName === 'A' && el.href && !props.url) {
      props.url = el.href;
    }
    if (!props.page_location) {
      props.page_location = location.pathname;
    }
  }
})();
